import * as React from 'react';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { DeadlineProvider } from './contexts/DeadlineContext'
import Login from './Auth/Login';
import ConferenceParticipantLogin from './Auth/ConferenceParticipantLogin';
import Register from './Auth/Register';
import ForgotPassword from './Auth/ForgotPassword';
import ResetPassword from './Auth/ResetPassword';

import ConferenceForgetPassword from './Auth/Conference/ConferencePassowrd/ConferenceForgetPassword';
import ConferenceRestPassword from './Auth/Conference/ConferencePassowrd/ConferenceRestPassword';


import Home from './frontend/Home';
import MasterLogin from './Auth/MasterLogin';
import AbstractHome from './frontend/abstact/Home';
// import AbstractLogin from './Auth/AbstractAuth/Login';
// import AbstractRegister from './Auth/AbstractAuth/Register';
import AbstractLogin from './Auth/AbstractAuth/AbstractLogin';
import AbstractRegister from './Auth/AbstractAuth/AbstractRegister';
import NewVerstionAbstractLogin from './Auth/AbstractAuth/NewVersion/NewVerstionAbstractLogin';
import NewVersionAbstractRegister from './Auth/AbstractAuth/NewVersion/NewVersionAbstractRegister';
import EventIDPage from './frontend/abstact/EventIDPage';
import PdfShow from './frontend/Exhibition/GuestBadge/PdfShow';
import Verifiction from './Auth/Exhibition/Verifiction';
import ExhibitionRegister from './Auth/Exhibition/ExhibitionRegister';
import EmailFound from './Auth/Exhibition/EmailFound';
import ExhibitionEventIDPage from './frontend/Exhibition/ExhibitionEventIDPage';
import Form from './Auth/Exhibition/Form';

import SpeakerRegistrationForm from './Auth/SpeakerRegistrationForm';

import ScanWorkshopQrCode from './components/Admin/WorkShops/ManageWorkShop/ScanWorkshopQrCode';
import WorkShopHome from './Auth/WorkShop/WorkShopHome';
import WorkShopEventID from './frontend/WorkShop/WorkShopEventID';
import Formbuilder from './Auth/Exhibition/Formbuilder';
import WorkShopParticpantVeri from './Auth/WorkShop/WorkShopParticpantVeri';
import WorkShopParticpantForm from './Auth/WorkShop/WorkShopParticpantForm';
import ThankYouWorkshopParticpant from './Auth/WorkShop/ThankYouWorkshopParticpant';
import BankPaymentVerification from './Auth/WorkShop/BankPaymentVerification';
import PaymentReturnUrl from './Auth/WorkShop/Payment/PaymentReturnUrl';
import ConferencePaymentRetrunRul from './Auth/Conference/ConferencePayment/ConferencePaymentRetrunRul';
import GroupConferencePaymentRetrunUrl from './Auth/Conference/ConferencePayment/GroupConferencePaymentRetrunUrl';
import UpdateWorkShops from './Auth/WorkShop/UpdateWorkShops';

//conference
import ConferenceEventID from './frontend/Conference/ConferenceEventID';
import ConferenceLoginEventId from './frontend/Conference/ConferenceLoginEventId';
import ConferenceSpeakerEventId from './frontend/Conference/ConferenceSpeakerEventId';
import ConferencePartiticpantVerirication from './Auth/Conference/ConferencePartiticpantVerirication';
import ConferencePartiticpantForm from './Auth/Conference/ConferencePartiticpantForm';
import ThankYouConferenceParticipant from './Auth/Conference/ThankYouConferenceParticipant';
import SpeakerThankYouPage from './Auth/SpeakerThankYouPage';
import UpdateConfereceParticipant from './Auth/Conference/UpdateConfereceParticipant';
import ConferenceBankPayemntForm from './Auth/Conference/ConferenceBankPayemntForm';
import ConferenceAttendance from './components/Admin/Conference/ManageConference/ConferenceAttendance';
import ConferenceBadgePdf from './frontend/Conference/ConferenceBadgePdf';
import ConferenceReceiptPdf from './frontend/Conference/ConferenceReceiptPdf';

import ConferenceParticpantGroupRegistarton from './Auth/Conference/ConferenceParticpantGroupRegistarton';
import ClamConferenceCouponEventId from './frontend/Conference/ClamConferenceCouponEventId';
import ClamCoupon from './Auth/Conference/ClamCoupon/ClamCoupon';
import ConferenceTermsAndConditions from './Auth/Conference/ConferenceTermsAndConditions';
import EvaluationFormVerification from './Auth/Conference/Evaluate/EvaluationFormVerification';
import ConferenceEvaluationEventId from './frontend/Conference/ConferenceEvaluationEventId';
import ConferenceEvaluteQuestions from './Auth/Conference/Evaluate/ConferenceEvaluteQuestions';
import ConferenceEvalutionThankYou from './Auth/Conference/Evaluate/ConferenceEvalutionThankYou';




import SendMessage from './WebSocket/SendMessage ';

//Affoliation
import AffiliationTagId from './frontend/Affiliation/AffiliationTagId';
import AffiliationConferenceBadgePdf from './frontend/Affiliation/AffiliationConferenceBadgePdf';
import AdminPrivateRoute from './Routes/AdminPrivateRoute';
import MasterAdminPrivateRoute from './Routes/MasterAdminPrivateRoute';
import './App.css';
import axios from 'axios';




//axios.defaults.baseURL = "http://127.0.0.1:8000/";
axios.defaults.baseURL = "https://api.cloudregis.com/";
//live this is link
//axios.defaults.baseURL ="https://cloudregis.com/v4.1/public/";


//axios.defaults.baseURL ="http://5.78.54.158/v2/laravel/public/";
//axios.defaults.baseURL ="https://cloudregis.com/v2/laravel/public/";
//axios.defaults.baseURL ="https://cloudregis.com/v3.1/laravel/public/";
//axios.defaults.baseURL ="https://cloudregis.com/v4/public/";


//axios.defaults.baseURL ="https://dev.cloudregis.com/v2/laravel/public/";
//axios.defaults.baseURL ="https://dev.cloudregis.com/v3/laravel/public/";
//axios.defaults.baseURL ="https://dev.cloudregis.com/v3.1/public/";
//axios.defaults.baseURL ="https://dev.cloudregis.com/v4/public/";


//axios.defaults.baseURL ="https://dev.cloudregis.com/v4.1/laravel/public/";
//axios.defaults.baseURL ="https://dev.cloudregis.com/v4.02/laravel/public/";
//axios.defaults.baseURL ="https://dev.cloudregis.com/v4.03/laravel/public/";
//axios.defaults.baseURL ="https://dev.cloudregis.com/v4.4/laravel/public/";
//axios.defaults.baseURL ="https://dev.cloudregis.com/v4.5/laravel/public/";

//axios.defaults.baseURL ="https://dev.cloudregis.com/v4.6/laravel/public/";
//axios.defaults.baseURL ="https://dev.cloudregis.com/v4.7/laravel/public/";
//axios.defaults.baseURL ="https://dev.cloudregis.com/checking/laravel/public/";


axios.defaults.headers.post['Content-Type'] = "application/json";
axios.defaults.headers.post['Accept'] = "application/json";
axios.defaults.withCredentials = true;
{/*For logout use*/ }
axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem('auth_token');
  config.headers.Authorization = token ? `Bearer ${token}` : '';
  return config;
});


const mdTheme = createTheme();


function App() {
  return (
    <ThemeProvider theme={mdTheme}>
      {/* <DeadlineProvider> */}
      <HashRouter>
        
       
     {/* <SendMessage /> Sends messages via API */}
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/login" component={Login} />
          {/* Conference Participant Login */}
          <Route path="/conference-participant-login" component={ConferenceParticipantLogin} />
             <Route path="/conference/forget-password" component={ConferenceForgetPassword} />
          <Route path="/conference/reset/password/:id" exact={true} component={ConferenceRestPassword} />
          
          <Route path="/register" component={Register} />
          <Route path="/forgot/password" component={ForgotPassword} />
          <Route path="/reset/password/:id" exact={true} component={ResetPassword} />
          <Route path="/abstract" component={AbstractHome} />
          {/* Abstract FrontEnd Routs */}
          <Route path="/abstract-login" component={AbstractLogin} />
          <Route path="/abstract-register" component={AbstractRegister} />
          <Route path="/abstract-author" component={EventIDPage} />
          <Route path="/author/login" component={NewVerstionAbstractLogin} />
          <Route path="/author/register" component={NewVersionAbstractRegister} />
         

          {/* Exhibition FrontEnd Routs */}
          <Route path="/exhibition/verification" component={Verifiction} />
          <Route path="/exhibition/register" component={ExhibitionRegister} />
          <Route path="/exhibition/email-found" component={EmailFound} />
          <Route path="/exhibition/guest" component={ExhibitionEventIDPage} />
          <Route path="/exhibition/guest-form" component={Form} />
          <Route path="/exhibition/formbuilder" component={Formbuilder} />
          <Route path="/exhibition/guest-badge" component={PdfShow} />




          <Route path="/workshop/attendance/:id" component={ScanWorkshopQrCode} />
          <Route path="/workshop/registration" component={WorkShopEventID} />
          <Route path="/workshop/home" component={WorkShopHome} />
          <Route path="/workshop/particpant-verification" component={WorkShopParticpantVeri} />
          <Route path="/workshop/particpant-form" component={WorkShopParticpantForm} />
          <Route path="/workshop/thank-you" component={ThankYouWorkshopParticpant} />
          <Route path="/bank-payment-verification" component={BankPaymentVerification} />
          <Route path="/payments/callback/return/" component={PaymentReturnUrl} />

          <Route path="/cpayments/callback/return/" component={ConferencePaymentRetrunRul} />
          <Route path="/cgpayments/callback/return/" component={GroupConferencePaymentRetrunUrl} />

          <Route path="/workshop/registration-update/:id" component={UpdateWorkShops} />

          {/*//conference Regisration */}
          <Route path="/conference/registration" component={ConferenceEventID} />
          <Route path="/conference/participant-login" component={ConferenceLoginEventId} />
          <Route path="/conference/speaker" component={ConferenceSpeakerEventId} />
          
          <Route path="/conference/particpant-verification" component={ConferencePartiticpantVerirication} />
          <Route path="/conference/particpant-form" component={ConferencePartiticpantForm} />
          <Route path="/conference/thank-you" component={ThankYouConferenceParticipant} />
         
          <Route path="/conference/registration-update/:id" component={UpdateConfereceParticipant} />
          <Route path="/conference-bank-payment" component={ConferenceBankPayemntForm} />
          <Route path="/conference/attendance/:id" component={ConferenceAttendance} />
          <Route path="/conference/participants-badge" component={ConferenceBadgePdf} />
           <Route path="/conference/participants-receipt" component={ConferenceReceiptPdf} />
          <Route path="/conference/event-discount/:eventId" component={AffiliationTagId} />
          <Route path="/conference/participants-group-registration" component={ConferenceParticpantGroupRegistarton} />
          <Route path="/conference/clam-coupon-event/:id" component={ClamConferenceCouponEventId} />
          <Route path="/conference/clam-coupon" component={ClamCoupon} />
          <Route path="/conference/terms-and-conditions" component={ConferenceTermsAndConditions} />
           <Route path="/speaker-registration-form" component={SpeakerRegistrationForm} />
          <Route path="/conference/speaker-thank-you" component={SpeakerThankYouPage} />

          <Route path = "/conference/evaluation-event/:id" component = {ConferenceEvaluationEventId} />
           <Route path ="/conference/evaluation" component ={EvaluationFormVerification} />
          {/* <Route path = "/conference/evaluate-from/:id" component = {ConferenceEvaluteQuestions} /> */}
          {/* <Route path ="/conference/evaluation-thank-you/:id" component ={ConferenceEvalutionThankYou} /> */}
            <Route path = "/conference/evaluate-from" component = {ConferenceEvaluteQuestions} />
          <Route path ="/conference/evaluation-thank-you" component ={ConferenceEvalutionThankYou} />


       

          
          
          {/*WorkShop Routes */}
          <Route path="/affiliation-conference/participants-badge/" component={AffiliationConferenceBadgePdf} />


          {/*Routes For Admin */}
          <AdminPrivateRoute path='/admin' name="Admin" />

          <Route exact path="/master/login" component={MasterLogin} />
          <MasterAdminPrivateRoute path='/master' name="MasterAdmin" />
          {/* <AuthorPrivateRoutes path ='/author' name ="Author"/> */}

        </Switch>
      </HashRouter>
      {/* </DeadlineProvider> */}
    </ThemeProvider>
  );
}

export default App;
